import { nextIntersect, nextIdle } from "../../helpers"

class HighchartElement extends HTMLElement {
  async connectedCallback() {
    await nextIntersect(this)
    await nextIdle()

    const { Highcharts } = await import("../highcharts")
    Highcharts.chart(this, await this.#loadOptions())
  }

  #loadOptions() {
    const json = this.#takeAttribute("options")
    if (json) return JSON.parse(json)

    const src = this.#takeAttribute("src")
    if (src) return fetch(src).then((r) => r.json())
  }

  #takeAttribute(name) {
    const value = this.getAttribute(name)
    this.removeAttribute(name)
    return value
  }
}

customElements.define("high-chart", HighchartElement)
